import { render, staticRenderFns } from "./SimpleTableSortingButton.vue?vue&type=template&id=6c9a549e&scoped=true&lang=html&"
import script from "./SimpleTableSortingButton.vue?vue&type=script&lang=js&"
export * from "./SimpleTableSortingButton.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTableSortingButton.vue?vue&type=style&index=0&id=6c9a549e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a549e",
  null
  
)

export default component.exports